import { useCallback, useEffect, useRef, useState } from 'react'

// Default cooldown duration: 1 minute (in milliseconds)
const DEFAULT_COOLDOWN_MS = 60 * 1000

// Temporarily blocks an action for a given duration after it is triggered.
// Returns the blocking flag and a function to start the cooldown.
// Used to prevent repeated execution of Business Rules (apply / unapply) in a short period.
const useCooldown = (durationMs = DEFAULT_COOLDOWN_MS) => {
  // Whether the action is currently blocked
  const [isCoolingDown, setIsCoolingDown] = useState(false)
  // Keep the timeout id to be able to clear it on unmount
  const timeoutRef = useRef(null)

  // Starts (or restarts) the blocking period
  const startCooldown = useCallback(() => {
    setIsCoolingDown(true)
    if (timeoutRef.current) clearTimeout(timeoutRef.current)
    timeoutRef.current = setTimeout(() => setIsCoolingDown(false), durationMs)
  }, [durationMs])

  // Clean up the pending timeout when the component unmounts
  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current)
    }
  }, [])

  return { isCoolingDown, startCooldown }
}

export default useCooldown
